import React, { ButtonHTMLAttributes } from 'react'
import classNames from 'classnames'

type ButtonSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

type ButtonProps = {
  size?: ButtonSize
} & ButtonHTMLAttributes<HTMLButtonElement>

const getSizeClassName = (size: ButtonSize): string => {
  switch (size) {
    case 'xs':
      return 'px-2 py-1 text-xs'
    case 'sm':
      return 'px-2 py-1 text-sm'
    case 'md':
      return 'rounded-md bg-white px-2.5 py-1.5 text-sm'
    case 'lg':
      return 'rounded-md bg-white px-3 py-2 text-sm'
    case 'xl':
      return 'rounded-md bg-white px-3.5 py-2.5 text-sm'
    default:
      return 'px-2 py-1 text-xs'
  }
}

const SecondaryButton: React.FC<ButtonProps> = ({
  size = 'md',
  children,
  className,
  ...props
}) => {
  const sizeClassName = getSizeClassName(size)

  return (
    <button
      type="button"
      className={classNames(
        `rounded bg-white font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50`,
        sizeClassName,
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}

export default SecondaryButton
